import { render } from "./AddChannel.vue?vue&type=template&id=a16b198a&scoped=true"
import script from "./AddChannel.vue?vue&type=script&lang=js"
export * from "./AddChannel.vue?vue&type=script&lang=js"

import "./AddChannel.vue?vue&type=style&index=0&id=a16b198a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a16b198a"]])

export default __exports__